module.exports = __webpack_public_path__ + "static/media/rain-ambience.cef2d74f.mp3";